import { Injectable } from '@angular/core';
import { URLSearchParams, Http, Response } from '@angular/http';
import {Observable} from 'rxjs/Rx';
import { Film } from 'models/film';
import { Person } from 'models/person';
import { Planet } from 'models/planet';
import { Species } from 'models/species';
import { Starship } from 'models/starship';
import { Vehicle } from 'models/vehicle';

@Injectable()
export class SwapiService{
    private swapiAPIURL : string = 'https://swapi.co/api/';
    constructor(private http: Http){

    }

    getData(url : string, type:Type) : Promise<Request> {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            params.set('format', 'json');
            this.http.get(url, {'search': params}).subscribe(data => {
                let dataJSON : Request = data.json();
                dataJSON.type = type;
                resolve(dataJSON);
            });
        });
    }

    getItem(url:string) : Promise<any> {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            params.set('format', 'json');
            this.http.get(url, {'search': params}).subscribe(data => {
                let dataJSON = data.json();
                resolve(dataJSON);
            });
        });
    }   

    getFilms(search :string ) : Promise<Request> {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            params.set('search', search);
            params.set('format', 'json');
            let apiURL = this.swapiAPIURL + 'films/'
            this.http.get(apiURL, {'search': params}).subscribe(data => {
                let filmsJSON : Request = data.json();
                filmsJSON.type = Type.film;
                resolve(filmsJSON);
            });
        });
    }

    getPeople(search : string) : Promise<Request> {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            params.set('search', search);
            params.set('format', 'json');
            let apiURL = this.swapiAPIURL + 'people/'

            this.http.get(apiURL, {'search': params}).subscribe(data => {
                let personJson : Request = data.json();
                personJson.type = Type.person;
                resolve(personJson);
            });
        });
    }

    getStarships(search : string) : Promise<Request> {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            params.set('search', search);
            params.set('format', 'json');
            let apiURL = this.swapiAPIURL + 'starships/'

            this.http.get(apiURL, {'search': params}).subscribe(data => {
                let starshipJson : Request = data.json();
                starshipJson.type = Type.starship;
                resolve(starshipJson);
            });
        });
    }

    getVehicles(search : string) : Promise<Request> {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            params.set('search', search);
            params.set('format', 'json');
            let apiURL = this.swapiAPIURL + 'vehicles/'

            this.http.get(apiURL, {'search': params}).subscribe(data => {
                let vehicleJson : Request = data.json();
                vehicleJson.type = Type.vehicle;
                resolve(vehicleJson);
            });
        });
    }

    getSpecies(search:string) : Promise<Request> {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            params.set('search', search);
            params.set('format', 'json');
            let apiURL = this.swapiAPIURL + 'species/'

            this.http.get(apiURL, {'search': params}).subscribe(data => {
                let speciesJson : Request = data.json();
                speciesJson.type = Type.species;
                resolve(speciesJson);
            });
        });
    }

    getPlanets(search:string) : Promise<Request> {
        return new Promise((resolve, reject) => {
            let params = new URLSearchParams();
            params.set('search', search);
            params.set('format', 'json');
            let apiURL = this.swapiAPIURL + 'planets/'

            this.http.get(apiURL, {'search': params}).subscribe(data => {
                let planetJson : Request = data.json();
                planetJson.type = Type.planet;
                resolve(planetJson);
            });
        });
    }

    
}

export class Request {
    count : number;
    next : string;
    previous : string;
    results: any[];
    type: Type
}

export enum Type{
    film,
    person,
    planet,
    species,
    starship,
    vehicle
}


// WEBPACK FOOTER //
// ./src/app/swapi.service.ts